import { useEffect } from 'react';
import translations from '../../../translations';
import ButtonDefault from '../../buttons/ButtonDefault';
import ButtonPrimary from '../../buttons/ButtonPrimary';
import GenericModal from '../../generic/modal/GenericModal';
import ModalBody from '../../generic/modal/ModalBody';
import ModalFooter from '../../generic/modal/ModalFooter';
import ModalHeader from '../../generic/modal/ModalHeader';
import ExportThemeForm from './ExportThemeForm';
import useThemeExport from './useThemeExport';

type Props = {
    onClose: () => void;
    show: boolean;
    modalContainer: HTMLElement | null | undefined;
};

const ExportThemeModal = ({ onClose, show, modalContainer }: Props) => {
    const {
        selectedEnvironment,
        setSelectedTheme,
        themes,
        environments,
        onEnvironmentSelect,
        tenant,
        onExport,
        resetSelection,
        isThemeSelected,
    } = useThemeExport(onClose);

    // Reset selection when modal is closed
    useEffect(() => {
        if (!show) {
            resetSelection();
        }
    }, [show, resetSelection]);

    return (
        <GenericModal
            show={show}
            onHide={onClose}
            container={modalContainer}
            dialogClassName="export-theme-modal modal-dialog-small"
        >
            <ModalHeader onHide={onClose}>
                <h4 className="modal-title">{translations.THEMES_export_heading}</h4>
            </ModalHeader>
            <ModalBody className="auto-height">
                <ExportThemeForm
                    selectedEnvironment={selectedEnvironment}
                    setSelectedTheme={setSelectedTheme}
                    themes={themes}
                    environments={environments}
                    onEnvironmentSelect={onEnvironmentSelect}
                    tenant={tenant}
                />
            </ModalBody>
            <ModalFooter>
                <ButtonDefault onClick={onClose}>{translations.COMMON_cancel}</ButtonDefault>
                <ButtonPrimary onClick={onExport} disabled={!isThemeSelected}>
                    {translations.THEMES_export}
                </ButtonPrimary>
            </ModalFooter>
        </GenericModal>
    );
};

export default ExportThemeModal;
